<template>
    <div class="ps">
        <div class="ps_top">
            <i class="el-icon-edit"></i>
            <div>文章管理</div>
        </div>
        <div class="ps_search">
            <div class="search_box">
                <el-input class="" v-model="searchinput" placeholder="请输入内容"></el-input>
            </div>
            <div class="button_box">
                <el-button @click="resetting()">重置</el-button>
                <el-button @click="query()">查询</el-button>
            </div>
        </div>
        <div class="ps_add">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <template v-for="(item,index) of documenttype">

                    <el-tab-pane v-if="item.isExternal!=1" :label="item.name"  :name=item.id  :key="index"></el-tab-pane>
                </template>
            </el-tabs>
            <div>
                <el-button style="width: 100px;height: 40px;" @click="addvideo()" >添加视频</el-button>
                <el-button style="width: 100px;height: 40px;" @click="addarticle()" >添加文章</el-button>
            </div>
        </div>
        <div class="ps_table">
            <el-table
                :header-cell-style="{ background:'#e2d2d2'}"
                :data="tableData"
                style="width: 100%">
                <el-table-column
                    prop="title"
                    label="标题">
                </el-table-column>
                <el-table-column
                  
                    label="权限">
                    <template slot-scope="scope">
                        <div v-if="scope.row.authName=='普通会员'">全部可看</div>
                        <div v-else>{{ scope.row.authName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="hits"
                    label="点击量">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="发表时间">
                </el-table-column>
                <el-table-column
                    prop="publisherName"
                    label="发布人">
                </el-table-column>
                <el-table-column
                    label="操作">
                    <template slot-scope="scoped">
                        <el-button  type="text" @click="edit(scoped.row)">编辑</el-button>
                        <el-popconfirm
                            title="这是一段内容确定删除吗？"
                            @confirm="del(scoped.row)"
                            >
                            <el-button style="margin: 0px 5px;" type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                        <!-- <el-button  type="text" @click="del(scoped.row)">删除</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="ps_pagination">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page.currentPage"
                :page-sizes="[10, 20, 30, 40]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import baseurl from '../../utils/index'
    import axios from 'axios'
    export default{
        data(){
            return{
                baseurl,
                ruleForm:{
                    title: '',
                    address:'',
                    num:'',
                    url:'',
                },
                uploadfilename:'',//上传文件名称
                isupload:false,
                searchinput:'',
                tableData: [],
                page:{
                    pagesize:10,
                    pagescount:1,
                    totalElements:0,
                    currentPage:1
                },
                productDialogVisible:false,
                modifynumber:false,
                productTitle:'',
                scoped:null,
                checked:null,//全选
                checkList:[],//多选
                menulist:null,//权限列表
                checkAll: false,
                isIndeterminate:true,
                item:null,
                modifynumber:false,
                activeName: "1",
                selectactive:1,
                documenttype:null,
                dialogvqrc:false,//查看二维码
                dialogvqrcimg:'',
            }
        },
        created(){
            this.module()
            
            // console.log(this.$route.query.selectactive);
            if(this.$route.query.selectactive!=undefined){

                this.activeName=this.$route.query.selectactive.toString()
                this.selectactive=this.$route.query.selectactive
                this.axioslist(this.$route.query.selectactive)

            }else{
                this.axioslist(1)
            }
            // console.log( this.$route.query.selectactive.toString);
             // this.activeName=Number() tab.index.toString()
        },
        methods:{
            //添加视频
            addvideo(){
                // console.log(1111,this.selectactive);
                this.$router.push({
                    path:'/addvideo',
                    query:{selectactive:this.selectactive}
                })
            },
            //添加文章
            addarticle(){
                this.$router.push({
                    path:'/addarticle',
                    query:{selectactive:this.selectactive,}
                })
            },
           
            //文章类型切换
            handleClick(tab, event){
                console.log(11111,tab);
                // this.activeName=Number() tab.index.toString()
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1;
                this.selectactive=Number( tab.index)+1
                this.axioslist(Number( tab.index)+1)
            },
            module(){
                this.$http.get('/module').then((res)=>{
                    if(res.code==200){
                        for (let i = 0; i <Object.keys( res.data).length; i++) {
                            res.data[i].id=res.data[i].id.toString()
                        }
                        this.documenttype=res.data
                    }
                })
            },
            //删除
            del(scoped){
                console.log(111,scoped);
                this.$http.delete(`/article?id=${scoped.id}`).then((res)=>{
                    console.log(res);
                    if(res.code==200){
                        this.$message({
                            message:'删除成功',
                            type:'success'
                        })
                        this.page.pagesize=10;
                        this.page.pagescount=1;
                        this.page.currentPage=1;
                        this.axioslist(this.selectactive)
                    }
                })
            },
            //编辑产品
            edit(scoped){
                console.log(111,scoped);
                if(scoped.contentType==1){
                    this.$router.push({
                        path:'/addarticle',
                        query:{'isedit':true,'selectactive':this.selectactive,id:scoped.id}
                    })
                    sessionStorage.setItem('scoped',JSON.stringify( scoped))
                }else if(scoped.contentType==2){
                    this.$router.push({
                        path:'/addvideo',
                        query:{'isedit':true,'selectactive':this.selectactive,id:scoped.id}
                    })
                    sessionStorage.setItem('scoped',JSON.stringify( scoped))
                }
                
            },
            //请求数据列表
            axioslist(type){
                let obj={
                    pageIndex:this.page.pagescount,//页码
                    pageSize:this.page.pagesize,//页面大小
                    key:this.searchinput,//描述
                }
                // console.log(111,Number( type));
                this.$http.get(`/page/article?pageIndex=${this.page.pagescount}&pageSize=${this.page.pagesize}&key=${this.searchinput}&moduleId=${Number( type)}`).then((res)=>{
                    if(res.code==200){;
                        this.page.totalElements=res.data.totalElements
                        this.tableData=res.data.data;

                    }
                })
            },
            //重置
            resetting(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.searchinput='';
                this.activeName='1'
                this.axioslist(this.selectactive)
            },
            //查询
            query(){
                this.page.pagesize=10;
                this.page.pagescount=1;
                this.page.currentPage=1
                this.axioslist(this.selectactive)
            },
            handleCurrentChange(val){
                this.page.pagescount=val;
                this.page.currentPage=val;
                
                this.axioslist(this.selectactive)
                console.log(111,this.selectactive);
            },
            handleSizeChange(val){
                this.page.pagesize=val;
                this.axioslist(this.selectactive)
                console.log(222,this.selectactive);
            },
        }
    }
</script>
<style lang="less" scoped>
   .dislogimg{
    display: flex;
    justify-content: center;
   }
    .avatar-uploader{
        border: 1px solid #797979;
        width: 130px;
        height: 30px;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        margin-top: 5px;
    }
    .avatar-uploader .el-upload {
            border: 1px dashed #d9d9d9;
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
        }
        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }
        .avatar-uploader-icon {
            font-size: 28px;
            color: #8c939d;
            width: 50px;
            height: 50px;
            line-height: 50px;
            text-align: center;
        }
        .avatar {
            width: 50px;
            height: 50px;
            display: block;
        }
    .choice_box{
        box-sizing: border-box;
        padding-left: 20px;
    }
    /deep/.el-textarea__inner{
        resize:none
    }
    /deep/.el-form-item__label::before{
        content: '*';
        color: red;
        margin-right: 5px;
    }
    
    textarea:focus {
    outline: none
    }
    .not_upload{
        border: 1px  dashed red ;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    .ps{
        width: 100%;
        height: 100%;
        box-sizing: border-box ;
        background: #fff;
        min-height: 829px;
        padding: 10px 20px;
        .ps_top{
            width: 100%;
            height: 20px;
            display: flex;
            align-items: center;
            box-sizing: border-box
        }
        .ps_search{
            box-sizing: border-box;
            width:100%;
            height: 50px;
            border: 1px solid #d7d7d7;
            margin: 10px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 0px;
            .search_box{
                box-sizing: border-box;
                padding-left: 20px;
                width: 300px;
            }
            .button_box{
                box-sizing: border-box;
                padding-right: 20px;
            }
        }
        .ps_add{
            width: 100%;
            display: flex;
            justify-content: space-between ;
        }
        .ps_table{
            width: 100%;
            max-height: 75%;
            overflow: scroll;
            overflow-x: hidden;
            box-sizing: border-box;
            margin: 10px 0px;
            .img_box{
                border: 1px solid red;
            }
        }
        .ps_pagination{
            width: 100%;
            height: 5%;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: right;
        }
        .dislogp{
           .itemtwo{
                .refresh{
                    line-height: 15px;
                }
           }
        }
    }
</style>